import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import './style.scss';
import CategoryActions from '@Actions/categoryActions';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class CategoryFilter extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {(*&)|*}
   */
  static getDerivedStateFromProps(props, state) {
    const { getCategories, user, noApiCall } = props;
    const { isUserReady } = state;
    if (user?.tenant_info?.tenant_id && !isUserReady && !noApiCall) {
      getCategories(user?.tenant_info?.org_id);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      user, categories, onChange, selectedCategory, disabled, title, hideTitle, containerClassName,
      inputClassName, labelClassName, getCategories, placeholder, style, isFilter, getCategoriesLoading,
    } = this.props;
    return (
      <div className={containerClassName}>
        {!hideTitle && (
          <div className={labelClassName || 'orgFormLabel'}>
            {title || 'Category'}
          </div>
        ) }
        <div className={inputClassName}>
          <PRZSelect
            value={selectedCategory}
            filterOption={false}
            disabled={disabled}
            onChange={(value) => onChange(value === 'All' ? 'All' : categories?.data.filter((category) => category?.product_category_name === value)[0])}
            showSearch
            onSearch={(value) => {
              getCategories(user?.tenant_info?.org_id, null, null, value);
            }}
            placeholder={placeholder}
            style={style}
            loading={getCategoriesLoading}
            allowClear
            onClear={() => {
              onChange('All');
              getCategories(user?.tenant_info?.org_id, null, null, '');
            }}
          >
            { isFilter && (
              <Option key={0} value="All">
                All Category
              </Option>
            )}
            {categories && categories.data && categories.data
              .map((item) => (

                <Option key={item.product_category_id} value={item.product_category_name}>
                  {`${item?.product_category_name }`}
                </Option>
              ))}

          </PRZSelect>
        </div>
      </div>

    );
  }
}

const mapStateToProps = ({ UserReducers, CategoryReducers }) => ({
  user: UserReducers.user,
  getCategoriesLoading: CategoryReducers.getCategoriesLoading,
  categories: CategoryReducers.categories,
});

const mapDispatchToProps = (dispatch) => ({
  getCategories: (orgId, page, limit, searchKeyword) => dispatch(CategoryActions.getCategories(orgId, page, limit, searchKeyword)),
});

CategoryFilter.propTypes = {
  user: PropTypes.any,
  placeholder: PropTypes.any,
  categories: PropTypes.any,
  selectedCategory: PropTypes.any,
  getCategories: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  style: PropTypes.any,
  isFilter: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CategoryFilter));
